import { render, staticRenderFns } from "./DepTree.vue?vue&type=template&id=0e07ec98&scoped=true"
import script from "./DepTree.vue?vue&type=script&lang=ts"
export * from "./DepTree.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e07ec98",
  null
  
)

export default component.exports